/**
 * Movepro CRM API interface
 *
 * @package Movepro CRM
 * @module MobileTerminal
 */

const ROUTE = '/mobile/terminal';

function getTapToPaySetupStatus() {
    return window.tenantAxios.get(`${ROUTE}/tap-to-pay/setup-status`);
}

function enableTapToPay(payload) {
    return window.tenantAxios.post(`${ROUTE}/tap-to-pay/enable`, payload);
}

function disableTapToPay() {
    return window.tenantAxios.post(`${ROUTE}/tap-to-pay/disable`);
}

function setTapToPaySurcharging(enabled) {
    return window.tenantAxios.post(`${ROUTE}/tap-to-pay/surcharging`, { enabled });
}

function getTapToPayStaffAuthorization() {
    return window.tenantAxios.get(`${ROUTE}/tap-to-pay/staff-authorization`);
}

function setTapToPayStaffAuthorization(enabled) {
    return window.tenantAxios.post(`${ROUTE}/tap-to-pay/staff-authorization`, { enabled });
}

export default {
    getTapToPaySetupStatus,
    enableTapToPay,
    disableTapToPay,
    setTapToPaySurcharging,
    getTapToPayStaffAuthorization,
    setTapToPayStaffAuthorization,
};
